import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import { Alert, Button, Form, FormField, TextInput } from "../ui";
import type { FlashMessage } from "../../types/state";

interface BorrowCustomerFormProps extends WithTranslation {
  onCustomerCodeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  message?: FlashMessage | null;
  isAuthenticating?: boolean;
}

function BorrowCustomerForm({
  t,
  onCustomerCodeChange,
  onSubmit,
  message,
  isAuthenticating = false,
}: BorrowCustomerFormProps) {
  const codeId = "BorrowCustomerForm-code";
  const messageId = "BorrowCustomerForm-message";

  return (
    <Form action="/" onSubmit={onSubmit} className="Form BorrowCustomerForm" noValidate>
      {message ? (
        <Alert id={messageId} variant={message.type} className={"Form-message " + message.type}>
          {message.content}
        </Alert>
      ) : null}
      <FormField
        className="Form-line"
        label={t("login.label_customer_code")}
        htmlFor={codeId}
        hint={t("login.info_customer_code")}
      >
        <TextInput
          className="Form-input BorrowCustomerForm-email"
          name="text"
          id={codeId}
          onChange={onCustomerCodeChange}
          aria-describedby={[message ? messageId : null].filter(Boolean).join(" ")}
        />
      </FormField>
      <div className="Form-line isActionLine">
        <Button type="submit" size="lg" className="Button isLarge" loading={isAuthenticating}>
          {t("login.label_connect")}
        </Button>
      </div>
    </Form>
  );
}

export default compose(withTranslation())(BorrowCustomerForm);
